import React from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import * as fp from 'lodash/fp';
import { hideModal } from '../../../../redux/actions/modal';
import Icon from '../../../icon/Icon';
import text from '../../../../text';
import { Button } from '../../../button';
export var MP_DELETE_SHAPES_MODAL = 'MP_DELETE_SHAPES_MODAL';
export default function MpDeleteShapesModal(param) {
    var show = param.show, _param_onOk = param.onOk, onOk = _param_onOk === void 0 ? fp.noop : _param_onOk, handleDelete = param.handleDelete, _param_associatedAddOns = param.associatedAddOns, associatedAddOns = _param_associatedAddOns === void 0 ? [] : _param_associatedAddOns, _param_isMany = param.isMany, isMany = _param_isMany === void 0 ? false : _param_isMany;
    var dispatch = useDispatch();
    var handleHide = function() {
        return dispatch(hideModal(MP_DELETE_SHAPES_MODAL));
    };
    var associatedAddOnDisplayNames = fp.uniq(associatedAddOns.map(function(param) {
        var display_name = param.display_name;
        return display_name;
    })).join(', ');
    return /*#__PURE__*/ React.createElement(Modal, {
        centered: true,
        className: "DeleteShapesModal",
        onHide: handleHide,
        show: show
    }, /*#__PURE__*/ React.createElement(Modal.Header, {
        className: "centered",
        closeButton: true
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "circled-exclamation"
    })), /*#__PURE__*/ React.createElement(Modal.Body, {
        className: "centered"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "mb-4"
    }, text(isMany ? 'deleteShapesWarning' : 'deleteShapeWarning')), associatedAddOnDisplayNames ? /*#__PURE__*/ React.createElement("p", {
        className: "mb-4 font-16 font-weight-bold"
    }, text('deleteShapesWarningAddOns', {
        addOns: associatedAddOnDisplayNames
    })) : null, /*#__PURE__*/ React.createElement("p", {
        className: "m-0"
    }, text(isMany ? 'deleteShapesMessage' : 'deleteShapeMessage'))), /*#__PURE__*/ React.createElement(Modal.Footer, {
        className: "flex-column justify-content-center"
    }, /*#__PURE__*/ React.createElement(Button, {
        autoFocus: true,
        onClick: function() {
            handleDelete();
            onOk();
            handleHide();
        }
    }, text(isMany ? 'yesDeleteShapes' : 'yesDeleteShape')), /*#__PURE__*/ React.createElement(Button, {
        onClick: handleHide,
        variant: "link"
    }, text('noCancel'))));
}
